import { createPartyResolver } from '../../party-activity/partyActivity.model';
import { getDealObligations, isCancelledRecord, isSettled, normalizedStatus } from '../../dashboard/utils/dashboard.obligations';
import { getUpcomingEventsCount } from '../../dashboard/utils/dashboard.helpers';
import { getDealRevenueCents } from '../../../shared/utils/dealRevenue';
import { parseEuroToCents } from '../../../shared/utils/installments';

// Use the same entity links, installment ledger and company share as the module metrics.
export function buildStaffOverview(staffMember, data = {}) {
  const resolve = createPartyResolver('staff', [staffMember], data);
  const linked = (row, type) => resolve(row, type).has(String(staffMember.id));
  const completedSources = new Set((data.dealsCompleted || []).map(row => String(row.sourceInProgressDealId)));
  const promotedSources = new Set((data.dealsInProgress || []).map(row => String(row.sourceProposalId)));
  const open = row => !isCancelledRecord(row) && !row.revertedAt
    && !['completato', 'completata', 'completed', 'chiuso', 'chiusa'].includes(normalizedStatus(row.status));
  const proposals = (data.dealProposals || []).filter(row => open(row) && !row.inProgressDealId
    && !promotedSources.has(String(row.id)) && linked(row, 'proposal'));
  const deals = (data.dealsInProgress || []).filter(row => open(row) && !row.completedDealId
    && !completedSources.has(String(row.id)) && linked(row, 'inProgressDeal'));
  const payments = (data.payments || []).filter(row => !isCancelledRecord(row) && !isSettled(row.status) && linked(row, 'payment'));
  const obligations = getDealObligations({ ...data, dealProposals: proposals, dealsInProgress: deals })
    .filter(row => linked(row.raw, row.entityType));
  const outstandingAmounts = [...payments, ...obligations].map(row => parseEuroToCents(row.amount));
  const events = (data.calendarEvents || []).filter(row => !isCancelledRecord(row) && linked(row, 'calendarEvent'));

  return {
    proposalsCount: proposals.length,
    inProgressDealsCount: deals.length,
    openDealsCount: proposals.length + deals.length,
    pipelineValue: [...proposals, ...deals].reduce((sum, row) => sum + getDealRevenueCents(row), 0) / 100,
    outstandingAmount: outstandingAmounts.some(amount => amount == null)
      ? null : outstandingAmounts.reduce((sum, amount) => sum + amount, 0) / 100,
    upcomingEventsCount: getUpcomingEventsCount(events),
  };
}
